import { cn } from '@repo/lib/cn';
import { MarkdownParser } from '@repo/lib/markdown';

import { Image } from '@/components/ui/image';
import { AudioPlayer, VideoPlayer } from '@/components/ui/media-player';

interface MarkdownProps {
  content: string;
  imageClassName?: string;
  videoClassName?: string;
  audioClassName?: string;
  textClassName?: string;
}

export function Markdown(markdownProps: MarkdownProps) {
  const { content, audioClassName, imageClassName, textClassName, videoClassName } = markdownProps;
  const elements = MarkdownParser.parseMarkdown(content);

  return elements.map((element, index) => {
    switch (element.type) {
      case 'image':
        return <Image key={index} src={element.content} alt={element.props?.alt || 'Answer image'} className={cn(imageClassName)} />;
      case 'video':
        return <VideoPlayer key={index} src={element.content} title={element.props?.title || 'Answer video'} className={cn(videoClassName)} />;
      case 'audio':
        return <AudioPlayer key={index} src={element.content} className={cn(audioClassName)} />;
      case 'text':
      default:
        return (
          <p key={index} className={cn('text-base', textClassName)}>
            {element.content}
          </p>
        );
    }
  });
}
